module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('drag', {
    staticClass: "drag",
    attrs: {
      "transfer-data": {
        example: 'drag-html'
      }
    }
  }, [_vm._v("\n\t\tdrag\n\t\t"), _c('div', {
    staticClass: "drag-image",
    slot: "image"
  }, [_c('ul', [_c('li', [_vm._v("Drag")]), _vm._v(" "), _c('li', [_vm._v("Image")]), _vm._v(" "), _c('li', [_vm._v("HTML")])])])]), _vm._v(" "), _c('drop', {
    staticClass: "drop",
    on: {
      "drop": _vm.handleDrop
    }
  }, [_vm._v("drop")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8eb8d2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/DragHtml.vue
// module id = 53
// module chunks = 0